module.exports = __webpack_public_path__ + "static/media/18ECA21.6b5f60da.jpg";